import { LinearProgress } from "@mui/material";
import { ComponentType, ReactNode, Suspense } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import ErrorAlert from "./ErrorAlert";

export default function SuspenseBoundary({
  fallback,
  errorComp = ErrorAlert,
  children,
}: {
  fallback?: ReactNode;
  errorComp?: ComponentType<FallbackProps>;
  children: ReactNode;
}) {
  return (
    <Suspense fallback={fallback ?? <LinearProgress />}>
      <ErrorBoundary FallbackComponent={errorComp}>{children}</ErrorBoundary>
    </Suspense>
  );
}
